export const nodeNameTagNameMap = new Map([
  ['bullet_list', 'ul'],
  ['button', 'button'],
  ['citation', 'cite'],
  ['definition', 'dd'],
  ['definition_list', 'dl'],
  ['definition_list_item', 'dt'],
  ['div', 'div'],
  ['emphasis', 'em'],
  ['enumerated_list', 'ol'],
  ['glossary', 'div'],
  ['inline', 'span'],
  ['label', 'span'],
  ['list_item', 'li'],
  ['line', 'p'],
  ['paragraph', 'p'],
  ['rubric', 'h3'],
  ['strong', 'strong'],
  ['subscript', 'sub'],
  ['superscript', 'sup'],
  ['table', 'table'],
  ['tbody', 'tbody'],
  ['entry', 'td'],
  ['row', 'tr'],
  ['thead', 'thead'],
  ['term', 'dt'],
  ['title_reference', 'cite'],
])

export const nodeNameTemplateNameMap = new Map([
  ['#text', 'Text'],
  ['block_quote', 'BlockQuote'],
  ['caption', 'FigureCaption'],
  ['caption_number', 'CaptionNumber'],
  ['download_reference', 'DownloadReference'],
  ['footnote_reference', 'FootnoteReference'],
  ['index', 'Skip'],
  ['line_block', 'LineBlock'],
  ['literal_block', 'LiteralBlock'],
  ['math_block', 'MathBlock'],
  ['number_reference', 'NumberReference'],
])
